import { StringHelpers } from '@salesperformanceint/e4shared';

export const lmsSystems = [
    'highspot-dl',
    'lessonly',
    'learning360',
    'pulse',
    'gtm',
    'docebo',
    'learn2',
    'accelerate',
    'showpad',
    'challenger',
];

export const lmsSystemRefs = [
    'HIGHSPOT-DL',
    'LESS',
    '360L',
    'PULSE',
    'GTM',
    'DOCEBO',
    'ACCELERATE',
    'LEARN2',
    'SHOWPAD',
    'CHALLENGER',
];

export const lmsNightlySystems = ['highspot-dl', 'learning360', 'pulse', 'gtm', 'docebo', 'showpad'];

export const lmsToTranslate = lms =>
    lms ? StringHelpers.capitalise(lms.substring(0, lms.indexOf('-') > 0 ? lms.indexOf('-') : lms.length)) : '';
